import {
  formatPurchasePlanningNumber,
  formatPurchasePlanningPercent,
} from '../../../lib/purchasePlanningHelpers';

export function ContainerOptimizationInterpretationRail({
  filteredGroups,
  selectedGroupId,
  onSelectGroup,
}) {
  const highlighted = filteredGroups.slice(0, 8);

  return (
    <aside className="rounded-lg border border-gray-200 bg-white p-2 lg:p-4">
      <div>
        <h3 className="text-sm font-semibold text-gray-900">Optimization interpretation</h3>
        <p className="mt-1 text-xs text-gray-500">
          Container optimization accepts controlled overbuy when needed to satisfy MOQ, batching, and
          freight efficiency. It optimizes procurement efficiency, not perfect inventory precision.
        </p>
      </div>
      <div className="mt-4 space-y-2">
        {highlighted.length > 0 ? (
          highlighted.map(group => (
            <button
              key={group.id}
              type="button"
              className={`flex w-full items-start justify-between rounded-md border px-1.5 py-1.5 text-left transition lg:px-3 lg:py-3 ${
                selectedGroupId === group.id
                  ? 'border-gray-300 bg-gray-50'
                  : 'border-gray-200 bg-white hover:border-gray-300'
              }`}
              onClick={() => onSelectGroup?.(group.id)}
            >
              <div className="min-w-0 pr-3">
                <p className="truncate text-sm font-medium text-gray-900">{group.containerGroup}</p>
                <p className="mt-1 truncate text-xs text-gray-500">{group.supplier}</p>
                <p className="mt-2 text-[11px] uppercase tracking-[0.12em] text-gray-500">
                  {group.months.join(', ') || 'Unscheduled'}
                </p>
              </div>
              <div className="text-right">
                <p className="text-sm font-semibold text-gray-900">
                  {formatPurchasePlanningPercent(group.preFillUtilization)}
                </p>
                <p className="mt-1 text-xs text-gray-500">pre-fill</p>
                <p className="mt-2 text-[11px] text-gray-500">
                  {formatPurchasePlanningNumber(group.fillUnits)} fill
                </p>
              </div>
            </button>
          ))
        ) : (
          <div className="rounded-md border border-dashed border-gray-200 bg-white px-4 py-6 text-sm text-gray-500">
            No container pools are in scope for the current filters.
          </div>
        )}
      </div>
    </aside>
  );
}
